var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isHideHeader)?_c('Header'):_vm._e(),_c('router-view',{key:_vm.key}),_c('RightIconList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }